import getApiClient from "./../../../../../shared/api";
import { showInfo, showError, clearNotifications } from "./../../../../../notifications/ducks/actions";

export const UPLOAD_SHOTS = "UPLOAD_SHOTS";
export const UPLOAD_SHOTS_CLEAR_REDIRECT = "UPLOAD_SHOTS_CLEAR_REDIRECT";
export const UPLOAD_SHOTS_CLEAR_WARNINGS = "UPLOAD_SHOTS_CLEAR_WARNINGS";

export function uploadShots(filmId, formData, sceneId) {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_SHOTS,
      payload: getApiClient().post(`film/${filmId}/Scene/${sceneId}/Shot/Upload`, formData, {
        headers: {
          "content-type": `multipart/form-data`
        }
      })
    })
      .then((response) => {
        dispatch(showInfo(`Successfully uploaded shots`));
      })
      .catch((response) => {
        dispatch(showError(`Error uploading shots`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function clearWarnings() {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_SHOTS_CLEAR_WARNINGS,
    });
  };
}

export function clearRedirect() {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_SHOTS_CLEAR_REDIRECT,
    });
  };
}